import { render } from "./AiChatPanel.vue?vue&type=template&id=4983b70b&scoped=true&ts=true"
import script from "./AiChatPanel.vue?vue&type=script&lang=ts"
export * from "./AiChatPanel.vue?vue&type=script&lang=ts"

import "./AiChatPanel.vue?vue&type=style&index=0&id=4983b70b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4983b70b"]])

export default __exports__